import React from 'react'
import PropTypes from 'prop-types'

import { pick } from '@styled-system/props'

import Tag from './Tag/index'
import HeadingSubTitle from './HeadingSubTitle'
import HeadingTitle from './HeadingTitle'
import { Container } from './styles'

function Heading({
  fontSizes = { title: [28, 28, 40], sub: [14, 14, 16] },
  horizontalAlign = 'center',
  light = false,
  subTitleText = '',
  tagGlyph = {},
  tagText = '',
  tagTextAs = 'h3',
  titleText,
  titleTextAs = 'h2',
  verticalAlign = 'center',
  ...rest
}) {
  return (
    <Container
      {...pick(rest)}
      alignItems={[horizontalAlign]}
      justifyContent={[verticalAlign]}
    >
      {tagText ? (
        <Tag
          as={tagTextAs}
          glyph={tagGlyph}
          horizontalAlign={horizontalAlign}
          light={light}
          text={tagText}
        />
      ) : null}

      {titleText && (
        <HeadingTitle
          as={titleTextAs}
          fontSize={fontSizes?.title || [28, 40]}
          horizontalAlign={horizontalAlign}
          light={light}
          titleText={titleText}
        />
      )}

      {subTitleText && (
        <HeadingSubTitle
          fontSize={fontSizes?.sub}
          horizontalAlign={horizontalAlign}
          light={light}
          subTitleText={subTitleText}
        />
      )}
    </Container>
  )
}

Heading.propTypes = {
  fontSizes: PropTypes.shape({
    title: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.arrayOf(PropTypes.number),
    ]),
    sub: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.arrayOf(PropTypes.number),
    ]),
  }),
  horizontalAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  light: PropTypes.bool,
  mobileAlignLeft: PropTypes.bool,
  subTitleText: PropTypes.string,
  tagGlyph: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  tagText: PropTypes.string,
  tagTextAs: PropTypes.string,
  titleText: PropTypes.object.isRequired,
  titleTextAs: PropTypes.string,
  verticalAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}

export default Heading
